import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import {
  getHttpRequestLog,
  queryHttpRequestLog,
  type HttpRequestLogFilters,
} from "./api";

export function useHttpRequestLog(filters: HttpRequestLogFilters) {
  return useInfiniteQuery({
    queryKey: ["portal", "http-request-log", filters],
    queryFn: ({ pageParam }) => queryHttpRequestLog(filters, pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.meta.next ?? undefined,
  });
}

export function useHttpRequestLogDetail(id: string | null) {
  return useQuery({
    queryKey: ["portal", "http-request-log-detail", id],
    queryFn: () => getHttpRequestLog(id ?? ""),
    enabled: id !== null,
  });
}
